function view (path) {
  return () => import(/* webpackChunkName: '' */ '@/views/tm/' + path).then(m => m.default || m) // eslint-disable-line prefer-template
}

const tmRoutes = [
  {
    path: '/tm/dashboard',
    component: view('Dashboard'),
    name: 'tm.dashboard',
    meta: {
      breadcrumb: [
        {
          text: 'Home'
        },
        {
          text: 'Dashboard',
          active: true
        }
      ]
    }
  },
  {
    path: '/tm/sales-order-tracker/:status?',
    component: view('SalesOrderTracker'),
    name: 'tm.sales-order-tracker',
    meta: {
      breadcrumb: [
        {
          text: 'Home'
        },
        {
          text: 'Sales Order Tracker',
          active: true
        }
      ]
    }
  }
]

export default tmRoutes
